export default {
  // 輸入標題
  transferDirection: "轉賬方向",
  currencyToken: "幣種/代幣合約",
  tags: "標籤",
  functionSwitch: "功能開關",
  time: "時間",

  // 占位符
  pleaseSelect: "請選擇",
  startDate: "開始日期",
  endDate: "結束日期",

  // 按鈕和鏈接
  transactionQuantityConfig: "交易數量配置",
  moreFilters: "更多篩選項",
  cancel: "取消",
  confirm: "確定",

  // 轉賬方向選項
  outflow: "流出",
  inflow: "流入",
  bidirectional: "雙向",

  // 功能開關選項
  surveyData: "調證數據",
  surveyDataTooltip: "可擴展出已上傳調證的相關數據",
  firstInflow: "首筆流入",
  firstInflowTooltip: "擴展增加顯示首筆主幣流入地址",
  swapContract: "swap合約",
  swapContractTooltip: "可擴展出swap合約交易數據",

  // 幣種分類
  commonCurrency: "常用幣種",
  contractToken: "合約代幣",
  all: "全部",

  // 消息提示
  currencyUpdateSuccess: "幣種修改成功",
  timeUpdateSuccess: "時間修改成功",
  tagUpdateSuccess: "標籤修改成功",
  switchUpdateSuccess: "開關修改成功",
  directionUpdateSuccess: "轉賬方向修改成功",
  filterSuccess: "篩選成功",

  // 數據提示
  noDataFound: "未找到符合搜索內容的數據 請修正後重試",

  // 標籤提示
  exchangeAddressTooltip: "擴展地址只顯示交易所相關標籤的地址",
  maliciousAddressTooltip: "擴展地址只顯示惡意標籤的地址",
};
